import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/dashboard",
      name: "dashboard",
      meta: { requiresAuth: true, title: "routes.dashboard" },
      component: () => import("./main.vue")
    }
  ]
};
